import { findOptions, getDivergenceOrEqual } from "../../../helpers/StringHelper";

export const mapLocations = (data = [], options, max = 1) => {
  const {
    typeOfLocationOptions = [],
    provinceOptions = [],
    territoryOptions = [],
    sclStatuses = [],
    countryOptions = [],
    mineralOptions = [],
  } = options || {};

  const mapper = (d) => {
    return d.map((scl, i) => {
      const defaultStatus = { value: '--', label: '--', color: 'default' };
      const status = scl.status ? sclStatuses.find(s => s.value === scl.status) : defaultStatus;
      const province = provinceOptions.find(f => f.value === scl.administrativeLevel1);
      const territory = territoryOptions.find(f => f.value === scl.administrativeLevel2);
      const author = scl.author ? (scl.author.name || `${scl.author.firstName} ${scl.author.lastName}`) : '';
      const childrens = (scl.children || []);
      const config = {
        id: scl.datastakeId ? scl.datastakeId : '',
        locationName: scl.locationName ? scl.locationName : '-',
        author,
        authorId: scl.authorId ? scl.authorId : undefined,
        locationType: scl.category ? findOptions(scl.category, typeOfLocationOptions) : '-',
        category: scl.category,
        status: status,
        territory: territory ? territory.label : '-',
        province: province ? province.label : '-',
        nrOfWorkers: scl.totalNoOfWorkers ? scl.totalNoOfWorkers : '-',
        organisationName: scl?.organisationName ? scl.organisationName : '-',
        published: scl.published,
        version: scl.version,
        dbId: scl.id,
        pmeProject: scl.pmeProject,
        mineralTitleScope: (scl.materialHandled || []).map(val => {
          const type = (val || {}).type
          const v = (mineralOptions || []).find(m => m.value === type);
          return v ? v.label : type || '';
        }).join(', '),
        country: scl && scl.country
          ? findOptions(scl.country, countryOptions) : '',
        updatedAt: scl.updatedAt,
        publishedAt: scl.publishedAt,
      };
      if (childrens.length > max) {
        Object.assign(config, {
          children: mapLocations(childrens, { ...options, isChild: true }),
        });
        config.sourcesLen = config.children.length;
      }
      return getDivergenceOrEqual(config, ['nrOfWorkers']);
    });
  }

  if (typeof data === 'object' && !Array.isArray(data)) {
    return {
      published: mapper(data.published || []),
      unPublished: mapper(data.unPublished || []),
    };
  }

  return mapper(data);
}

export const getLocationFilterOptions = (options, view) => {
  const {
    typeOfLocationOptions = [],
    // provinceOptions = [],
    mineralOptions = [],
    sclStatuses = [],
    countryOptions = [],
    locationCategoryOptions,
    administrativeLevel1,
    administrativeLevel2,
  } = options || {};

  const defaultOptions = {
    status: sclStatuses,
    country: countryOptions,
    administrativeLevel1,
    administrativeLevel2,
  }

  if (view === 'scl') {
    return {
      ...defaultOptions,
      materialHandled: mineralOptions,
    };
  }

  if (view === 'locations') {
    return {
      ...defaultOptions,
      category: locationCategoryOptions || typeOfLocationOptions,
    };
  }

  return defaultOptions;
}

export const allStatuses = ['all', 'identified', 'inProgress', 'assessed', 'connected'];
